import React from "react"

/** Components */
import ContentPage from "./ContentPage"

export default function ContentMainPage() {
  return <ContentPage />
}
